import { render, staticRenderFns } from "./RoleUser.vue?vue&type=template&id=1e78a7d3&"
import script from "./RoleUser.vue?vue&type=script&lang=js&"
export * from "./RoleUser.vue?vue&type=script&lang=js&"
import style0 from "./RoleUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports